import { Suspense, useState } from "react";
import { breadcrumbLiquidacionDeuda } from "../utils/BreadcrumbItem";
import { Box, Paper } from "@mui/material";
import { FiltrosLiquidacionComponent, TablaLiquidacionComponent } from "../components";
import { FormFiltersLiquidacionInterface } from "../interfaces";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";

interface Props {};

const LiquidacionDeuda: React.FC<Props> = ({}: Props) => {
    
    const [formFilters, setFormFilters] = useState<FormFiltersLiquidacionInterface & { trigger: number }>({
        rutCliente: '',
        idSolicitud: '',
        idOperacion: '',
        nombreNuevoProveedor: '',
        rutNuevoProveedor: '',
        trigger: 0
    });

    const handleFilters = (formFilters: FormFiltersLiquidacionInterface) =>
        setFormFilters(prev => ({ ...formFilters, trigger: prev.trigger + 1 }));

    return (
        <Suspense>
            <Breadcrumb items={ breadcrumbLiquidacionDeuda } />
            <Box sx={{ mt: 2 }}>
                <Paper elevation={3} sx={{ p: 3 }}>
                    <Suspense>

                        <FiltrosLiquidacionComponent handleFilters={handleFilters} />

                        { formFilters.rutCliente.trim().length > 0 && 
                            <TablaLiquidacionComponent
                                key={formFilters.trigger}
                                idOperacion={formFilters.idOperacion}
                                idSolicitud={formFilters.idSolicitud}
                                nombreNuevoProveedor={formFilters.nombreNuevoProveedor}
                                rutCliente={formFilters.rutCliente}
                                rutNuevoProveedor={formFilters.rutNuevoProveedor}
                            /> 
                        }

                    </Suspense>
                </Paper>
            </Box>
        </Suspense>
    );
}

export default LiquidacionDeuda;